<div class="veiw-my-car">
  <div class="my-car-title">{{ 'MyCar' | translate }}</div>
  <div class="text-blue">{{ 'Pickup' | translate }}</div>
  <div class="mb-2"><fa-icon class="time-icon" [icon]="faMapMarkerAlt"></fa-icon> {{reservationCaseResult.fromAgencyName}}</div>
  <div class="mb-2"><fa-icon class="time-icon" [icon]="faCalendarAlt"></fa-icon> {{reservationCaseResult.startDateString}}</div>
  <div class="mb-2"><fa-icon class="time-icon" [icon]="faClock"></fa-icon> {{reservationCaseResult.startTimeString}}</div>
  <div class="text-blue">{{ 'Return' | translate }}</div>
  <div class="return-view-car">
  <div class="mb-2"><fa-icon class="time-icon" [icon]="faMapMarkerAlt"></fa-icon>{{reservationCaseResult.toAgencyName}}</div>
  <div class="mb-2"><fa-icon class="time-icon" [icon]="faCalendarAlt"></fa-icon>{{reservationCaseResult.endDateString}} </div>
  </div>
  <div class=""><fa-icon class="time-icon" [icon]="faClock"></fa-icon> {{reservationCaseResult.endTimeString}}</div>
</div>
